import {
  PostRegistrationPayload,
  PostRegistrationResponse,
} from 'api/typegen/registration/post';
import fetchWebApi from 'api/fetchWebApi';

const postRegistrationApiCall = async (
  payload: PostRegistrationPayload,
): Promise<PostRegistrationResponse> =>
  fetchWebApi('/registration', undefined, {
    method: 'post',
    body: JSON.stringify(payload),
  });

export default postRegistrationApiCall;
